import React from 'react';

function Footer() {
  return (
    <footer style={{ borderTop: '1px solid #E0DDD6', padding: '2rem', textAlign: 'center', fontFamily: 'DM Sans, system-ui, sans-serif', fontSize: 13, color: '#888880' }}>
      © {new Date().getFullYear()} HostelChic ·{' '}
      <span style={{ color: '#4A9E8A' }}>Browse anonymously, post when you're ready.</span>
    </footer>
  );
}

export default Footer;
